import React from "react";
import { useScrollReveal } from "hooks/useScrollReveal";

const ScrollReveal = ({ children, className = "" }) => {
  const { ref, visible } = useScrollReveal();

  return (
    <div
      ref={ref}
      className={`scroll-reveal${visible ? " scroll-reveal--visible" : ""}${
        className ? ` ${className}` : ""
      }`}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;
